import React, { useEffect, useState } from "react";
import { Badge, Col, Row } from "react-bootstrap";
import { SingleCardMetric } from "../reports/ui/SingleCardMetric";
import { Case } from "../../types/case";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

interface MyCasesTodayState {
  cases: Case[];
  otherCases: Case[];
  caseFilter: string;
  searchText: string;
  viewAll: boolean;
  onClickFilter: any;
  onClickClearFilters: any;
}

const MyCasesToday = ({ cases, otherCases, viewAll, caseFilter, searchText, onClickFilter, onClickClearFilters }: MyCasesTodayState) => {
  const [assessmentsDue, setAssessmentsDue] = useState<Case[]>([]);
  const [unreadMessages, setUnreadMessages] = useState<Case[]>([]);
  const [nextThing, setNextThing] = useState<Case[]>([]);

  useEffect(() => {
    var workingCases = viewAll ? [...cases, ...otherCases] : cases;
    const workingCases1 = workingCases.filter((c: any) => {
      return c.assessment_due;
    });
    setAssessmentsDue(workingCases1);

    const workingCases2 = workingCases.filter((c: any) => {
      return c.new_messages;
    });
    setUnreadMessages(workingCases2);

    const workingCases3 = workingCases.filter((c: any) => {
      return c.task_review;
    });
    setNextThing(workingCases3);
  }, [cases, otherCases, viewAll, searchText]);

  return (
    <>
      <Row className="mt-3 mb-2">
        <Col></Col>
        <Col className="col-3">
          <SingleCardMetric
            title="Assessment Due"
            total={assessmentsDue.length}
            onHandleClick={() => onClickFilter("assessment")}
            cursor={true}
            active={caseFilter === "assessment"}
          />
        </Col>
        <Col className="col-3">
          <SingleCardMetric
            title="Unread Messages"
            total={unreadMessages.length}
            onHandleClick={() => onClickFilter("messages")}
            cursor={true}
            active={caseFilter === "messages"}
          />
        </Col>
        <Col className="col-3">
          <SingleCardMetric
            title="Next Task Review"
            total={nextThing.length}
            onHandleClick={() => onClickFilter("task")}
            cursor={true}
            active={caseFilter === "task"}
          />
        </Col>
        <Col></Col>
      </Row>
      {caseFilter && (
        <Row className="mt-3">
          <Col className="col-12 text-center">
            <Badge className="app-tertiary-color-inverse" bg="none">
              {caseFilter === "assessment"
                ? "Assessment Due"
                : caseFilter === "messages"
                ? "Unread Messages"
                : caseFilter === "task"
                ? "Next Task Review"
                : "No Filters Applied"}
            </Badge>
            <Badge className="app-tertiary-color ms-1 cursor-pointer" bg="none" onClick={onClickClearFilters}>
              <FontAwesomeIcon icon={faClose}></FontAwesomeIcon>
            </Badge>
          </Col>
        </Row>
      )}
      <Row className="mt-4">
        <hr />
      </Row>
    </>
  );
};

export default MyCasesToday;
